import { Routes } from '@angular/router';
import { countriesListResolver } from '@df/api/config/contries-list.resolver';

export const loginRoutes: Routes = [
    {
        path: '',
        loadComponent: () =>
            import(
                /* webpackChunkName: "login-view.async" */
                './view/login-view.component'
            ).then(m => m.LoginViewComponent),
        children: [
            {
                path: '',
                loadComponent: () =>
                    import(
                        /* webpackChunkName: "login-form.async" */
                        './form/login-form.component'
                    ).then(m => m.LoginFormComponent),
                resolve: {
                    appMore: countriesListResolver
                }
            },
            {
                path: 'reset-password',
                loadComponent: () =>
                    import(
                        /* webpackChunkName: "login-reset-password.async" */
                        './reset-password/login-reset-password.component'
                    ).then(m => m.LoginResetPasswordComponent)
            }
        ]
    }
];
